import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  createContest,
  fetchContestDetails,
  fetchModuleDetails,
  getModuleList,
  updateContest,
} from "../../../action/contest";
import trashIcon from "../../../assets/images/trash-03.svg";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { SingleErrorMessage } from "../../singleErrorMessage";
import { toast } from "react-hot-toast";
import uploadImage from "../../../action/imageUpload";
import ThumbnailPicker from "../../../components/ThumbnailPicker/ThumbnailPicker";
import showNotification from "../../../components/notification/showNotification";
import { Loader } from "../../../components/loader";

const ContestEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [contestDetails, setContestDetails] = useState([]);
  const [quetionType, setQuetionType] = useState("TEXT");
  const [optionType, setOptionType] = useState("TEXT");
  const [optionTypeArr, setOptionTypeArr] = useState([]);
  const [partTab, setPartTab] = useState(1);
  const [type, setType] = useState(0);
  const [videoType] = useState([
    { name: "Upload Internal Video", value: 0 },
    { name: "Upload External Video", value: 1 },
  ]);

  const [moduleId, setModuleId] = useState("");
  const addContestFormik = useFormik({
    initialValues: {
      title: { en: "", hi: "", mr: "" },
      moduleId: "",
      options: [{ title: { en: "", hi: "", mr: "" }, isCorrect: false }],
      media: "",
      contestType: "",
      optionType: "",
      moduleCategoryId: "",
      extras: { videoUrlType: 0 },
    },
    onSubmit: async (values, { setSubmitting }) => {
      delete values.moduleId;
      values.contestType = quetionType;
      values.optionType = optionType;
      values.options = values.options.map(({ title, isCorrect }) => ({
        title, // Keep only the title object
        isCorrect, // Keep only the isCorrect flag
      }));
      if (values.options.length == 1) {
        showNotification("Error", "Please select 2 or more options", "danger");

        return;
      }
      if (values.media == "" || values.media == null) {
        delete values.media;
      }
      if (
        quetionType === "VIDEO" &&
        (values.extras.videoUrlType === 0 || values.extras.videoUrlType === 1)
      ) {
        if (
          values.media === null ||
          values.media === undefined ||
          values.media === ""
        ) {
          showNotification("Error", "Please select media", "danger");

          return;
        }
      }
      if (quetionType === "IMAGE") {
        if (
          values.media === null ||
          values.media === undefined ||
          values.media === ""
        ) {
          showNotification("Eror", "Please select image", "danger");
          return;
        }
      }

      // const isEmptyOption = values.options.filter(
      //   (option) => option.title.en === ""
      // );

      const isEmptyOption = values.options.filter((option) => {
        if (optionType === "TEXT") {
          return Object.keys(option.title).some(
            (lang) => !option.title[lang]?.trim()
          );
        } else if (optionType === "IMAGE") {
          return !option.title.en || option.title.en.trim() === "";
        }
        return false;
      });
      if (isEmptyOption.length > 0) {
        showNotification("Error", "Please fill option", "danger");

        return;
      }
      const isCorrectAns = values.options.filter(
        (option) => option.isCorrect == true
      );
      if (quetionType !== "VIDEO" && quetionType !== "IMAGE") {
        delete values.media;
      }
      if (isCorrectAns.length == 0) {
        showNotification(
          "Error",
          "Please select any one option as correct",
          "danger"
        );

        return;
      }

      try {
        setLoading(true);
        const res = await updateContest(id, values);
        if (res.status) {
          showNotification("Success", res.message, "success");
          navigate(-1);
        } else {
          showNotification("Error", res.message || res.massage, "danger");
          setSubmitting(false);
        }
      } catch (error) {
        showNotification(
          "Error",
          error?.message || "An error occurred while updating contest",
          "danger"
        );
        setSubmitting(false);
      } finally {
        setLoading(false);
      }
    },
  });
  const getModuleDetails = async () => {
    try {
      const response = await fetchModuleDetails(moduleId);
      if (response.status) {
        let moduleTypeArr = response.data[0].moduleType;
        addContestFormik.setFieldValue(
          "moduleCategoryId",
          response.data[0]?.moduleCategoryId
        );
        console.log(
          "response.data[0]?.moduleCategoryId",
          response.data[0]?.moduleCategoryId
        );
        // Set contest and option type arrays
        setContestDetails(moduleTypeArr);
        setOptionTypeArr(moduleTypeArr);

        // Check if moduleTypeArr contains only "IMAGE"
        if (moduleTypeArr.length === 1 && moduleTypeArr[0] === "IMAGE") {
          moduleTypeArr.push("TEXT");
          setOptionTypeArr(moduleTypeArr); // Update optionTypeArr to include "TEXT"
        }
        if (response.data[0].moduleType.length == 1) {
          setQuetionType(response.data[0].moduleType[0]);
          if (response.data[0].moduleType[0] === "VIDEO") {
            setOptionType("TEXT");
            setOptionTypeArr(["TEXT"]);
          }
        }
        // Set type based on media field
        const media = response.data[0].media;
        if (
          media &&
          (media.startsWith("http://") || media.startsWith("https://"))
        ) {
          setType("EXTERNAL_VIDEO");
        } else {
          setType("INTERNAL_VIDEO");
        }
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };

  const onCloseToaste = () => {
    toast.dismiss();
  };

  const addMoreOptions = () => {
    addContestFormik.setFieldValue("options", [
      ...addContestFormik.values.options,
      { title: { en: "" }, isCorrect: false },
    ]);
  };

  const addRemoveOptions = (mainIndex) => {
    addContestFormik.setFieldValue(
      "options",
      addContestFormik.values.options.filter(
        (value, index) => index !== mainIndex
      )
    );
  };

  const getContestDetails = async () => {
    const res = await fetchContestDetails(id);
    if (res.status) {
      console.log("response", res);
      setModuleId(res.data._id);
      setQuetionType(res.data?.contestType);
      addContestFormik.setFieldValue("moduleId", res.data._id);
      addContestFormik.setFieldValue(
        "moduleCategoryId",
        res.data.moduleCategoryId
      );
      addContestFormik.setFieldValue("title", res.data.title);
      addContestFormik.setFieldValue("options", res.data.options);
      addContestFormik.setFieldValue("contestType", res.data.contestType);
      addContestFormik.setFieldValue("media", res.data.media);
      addContestFormik.setFieldValue("optionType", res?.data?.optionType);
      addContestFormik.setFieldValue(
        "extras.videoUrlType",
        res?.data?.extras?.videoUrlType || 0
      );
      setOptionType(res?.data?.optionType);
      setVideoPreview(res.data?.media);

      const isFileOption = res.data.options.some((option) => {
        const titleEn = option.title.en;
        const fileExtensionRegex = /\.(jpg|jpeg|png)$/i; // Add any other extensions as needed

        return (
          titleEn && (titleEn.includes("/") || fileExtensionRegex.test(titleEn))
        );
      });
      if (isFileOption) setOptionType("IMAGE");
    }
  };

  const [videoPreview, setVideoPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // const handleVideoUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // Create a video element to generate a thumbnail
  //     const videoElement = document.createElement("video");
  //     videoElement.src = URL.createObjectURL(file);
  //     videoElement.currentTime = 1; // Set time at which to capture the thumbnail (e.g., 1 second)

  //     videoElement.onloadeddata = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = videoElement.videoWidth;
  //       canvas.height = videoElement.videoHeight;
  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
  //       const thumbnail = canvas.toDataURL("image/png");
  //       setVideoPreview(thumbnail); // Set the thumbnail as preview
  //       console.log(thumbnail);
  //     };

  //     const formData = new FormData();
  //     formData.append("file", file);

  //     try {
  //       const res = await uploadImage(formData, "module");
  //       if (res.status) {
  //         addContestFormik.setFieldValue(`media`, res.data[0]);
  //       }
  //     } catch (error) {
  //       console.error("Error uploading video:", error);
  //     }

  //     setVideoPreview(addContestFormik.values?.media);
  //   }
  // };
  // const handleVideoUpload = async (e) => {
  //   setLoading(true);
  //   const file = e.target.files[0];
  //   if (!file) return;
  //   const maxSize = 25 * 1024 * 1024; // 25MB in bytes

  //   if (file.size > maxSize) {
  //     showNotification("Error", "The file size must be less than 25MB.", "danger");
  //     setLoading(false);
  //     return;
  //   }
  //   // Create a video element to generate a thumbnail
  //   const videoElement = document.createElement("video");
  //   videoElement.src = URL.createObjectURL(file);
  //   videoElement.currentTime = 1; // Capture the thumbnail at 1 second

  //   videoElement.onloadeddata = () => {
  //     const canvas = document.createElement("canvas");
  //     canvas.width = videoElement.videoWidth;
  //     canvas.height = videoElement.videoHeight;
  //     const ctx = canvas.getContext("2d");
  //     ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
  //     const thumbnail = canvas.toDataURL("image/png");
  //     setVideoPreview(thumbnail); // Set the thumbnail as preview
  //   };

  //   const formData = new FormData();
  //   formData.append("file", file);

  //   try {
  //     const res = await uploadImage(formData, "module");
  //     if (res.status) {
  //       addContestFormik.setFieldValue(`media`, res.data[0]);
  //       console.log("Video uploaded successfully!");
  //     } else {
  //       console.log("Upload error");
  //     }
  //   } catch (error) {
  //     console.log("Error uploading video:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVideoUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;
    const maxSize = 8 * 1024 * 1024; // 8MB in bytes

    if (file.size > maxSize) {
      showNotification(
        "Error",
        "The file size must be less than 8MB.",
        "danger"
      );
      setLoading(false);
      addContestFormik.setFieldValue(`media`, ""); // Reset the file input when size > 8MB
      e.target.value = ""; // Clear the file input to reset the file name
      setVideoPreview(null);
      return;
    } else {
      console.log("selectVideo");

      // Create a video element to generate a thumbnail
      const videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(file);
      videoElement.currentTime = 1; // Capture the thumbnail at 1 second

      videoElement.onloadeddata = () => {
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        const thumbnail = canvas.toDataURL("image/png");
        setVideoPreview(thumbnail); // Set the thumbnail as preview
      };

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await uploadImage(formData, "module");
        console.log("Uploading video...");
        console.log("Response:", res);

        if (res.status) {
          addContestFormik.setFieldValue(`media`, res.data[0]);
          console.log("Video uploaded successfully!");
        } else {
          console.log("Upload error");
        }
      } catch (error) {
        console.log("Error uploading video:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const uploadMediaImage = async (file, type, index) => {
    if (!file?.type?.includes("image")) {
      toast.custom(
        <SingleErrorMessage
          data={"Please select an image"}
          error={true}
          bColor="#D92D20"
          onClose={onCloseToaste}
        />
      );
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    const res = await uploadImage(formData, "module");
    if (res.status) {
      if (type == 1) addContestFormik.setFieldValue(`media`, res.data[0]);
      else
        addContestFormik.setFieldValue(
          `options[${index}].title.en`,
          res.data[0]
        );
    }
  };

  useEffect(() => {
    getContestDetails();
  }, [id]);

  useEffect(() => {
    getModuleDetails();
  }, [moduleId]);
  const showCheckbox = (indx) => {
    if (addContestFormik.values.options?.[indx]?.isCorrect === true) {
      return false;
    }
    return (
      addContestFormik.values.options?.some(
        (value) => value?.isCorrect === true
      ) ?? false
    );
  };
  return (
    <div className="payout_data-content">
      {(loading || addContestFormik.isSubmitting) && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.5)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader />
        </div>
      )}
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              <Breadcrumb
                paths={[
                  {
                    name: "Question",
                    link: `/contest/list/${location.state?.id}`,
                    state: location.state?.pageno,
                  },
                  { name: "Edit Question", link: "/contest/edit" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tab_box">
        <form
          onSubmit={addContestFormik.handleSubmit}
          className="m-4">
          <div className="row">
            {contestDetails?.length > 0 ? (
              <>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Question Type</div>
                    <div className="input_field">
                      <select
                        required
                        type="text"
                        className="input"
                        placeholder="Level"
                        name="zone"
                        value={
                          contestDetails.length === 1
                            ? contestDetails[0]
                            : quetionType
                        }
                        onChange={(e) => {
                          setQuetionType(e.target.value);
                          if (e.target.value == "VIDEO") {
                            setOptionType("TEXT");
                          }
                        }}>
                        {contestDetails.length > 1 ? (
                          <option value="">Select Question Type</option>
                        ) : (
                          ""
                        )}
                        {contestDetails?.map((value) => {
                          return <option value={value}>{value}</option>;
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Option Type</div>
                    <div className="input_field">
                      <select
                        required
                        type="text"
                        className="input"
                        placeholder="Level"
                        name="zone"
                        value={optionType}
                        onChange={(e) => {
                          setOptionType(e.target.value);
                        }}
                        disabled={quetionType == "VIDEO"}>
                        {quetionType === "VIDEO" &&
                        contestDetails.length == 1 ? (
                          <option
                            value="TEXT"
                            selected>
                            TEXT
                          </option>
                        ) : (
                          <>
                            <option value="">Select Option Type</option>
                            {optionTypeArr
                              ?.filter((type) => type !== "VIDEO")
                              .map((value) => {
                                return (
                                  <option
                                    key={value}
                                    value={value}>
                                    {value}
                                  </option>
                                );
                              })}
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              " "
            )}
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Title</div>
                <div className="input_field">
                  <input
                    required
                    type="text"
                    className="input"
                    name="title.en"
                    placeholder="Enter title"
                    value={addContestFormik.values.title.en}
                    onChange={addContestFormik.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Title in Hindi</div>
                <div className="input_field">
                  <input
                    required
                    type="text"
                    className="input"
                    name="title.hi"
                    placeholder="Enter title"
                    value={addContestFormik.values.title.hi}
                    onChange={addContestFormik.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Title in Marathi</div>
                <div className="input_field">
                  <input
                    required
                    type="text"
                    className="input"
                    name="title.mr"
                    placeholder="Enter title"
                    value={addContestFormik.values.title.mr}
                    onChange={addContestFormik.handleChange}
                  />
                </div>
              </div>
            </div>
            {quetionType === "VIDEO" ? (
              <>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Video Type</div>
                    <div className="input_field">
                      <select
                        required
                        type="text"
                        className="input"
                        placeholder="Level"
                        name="extras.videoUrlType"
                        value={addContestFormik.values.extras.videoUrlType}
                        onChange={addContestFormik.handleChange}>
                        <option value="">Select Video Type</option>
                        {videoType?.map((value) => {
                          return (
                            <option value={value.value}>{value.name}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="col-lg-6"></div>
            )}
            <div className="col-lg-6">
              {quetionType == "IMAGE" ? (
                <div className="input-box">
                  <div className="input-label">Image</div>
                  <ThumbnailPicker
                    width="auto"
                    height="250px"
                    onFileSelect={(file) => {
                      const _URL = window.URL || window.webkitURL;

                      const img = new Image();
                      uploadMediaImage(file, 1);

                      img.src = _URL.createObjectURL(file);
                    }}
                    image={addContestFormik.values?.media}
                    accept={"image/*"}
                  />
                </div>
              ) : quetionType == "VIDEO" ? (
                <>
                  {addContestFormik.values.extras.videoUrlType == 0 ? (
                    <div className="input-box">
                      <div className="input-label">Upload video</div>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={handleVideoUpload}
                      />
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          {videoPreview && (
                            <div className="mt-3">
                              <video
                                width="300"
                                controls
                                key={addContestFormik?.values?.media}>
                                <source
                                  src={`${process.env.REACT_APP_S3_URL}/${addContestFormik.values?.media}`}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="input-box">
                      <div className="input-label">Video URL</div>
                      <div className="input_field">
                        <input
                          type="url"
                          className="input"
                          name="media"
                          placeholder="Enter url"
                          value={addContestFormik.values.media}
                          onChange={addContestFormik.handleChange}
                        />
                      </div>
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-6"></div>
            {addContestFormik.values.options?.map((value, index) => {
              return (
                <div className="col-lg-6">
                  {optionType == "TEXT" || quetionType == "VIDEO" ? (
                    <div className="input-box">
                      <div className="input-label option_type">
                        {" "}
                        <div> Option {index + 1}</div>
                        <div className="checkbox_div">
                          <input
                            style={{ width: "auto" }}
                            type="checkbox"
                            className="input"
                            name={`options[${index}].isCorrect`}
                            placeholder="Enter title"
                            checked={
                              addContestFormik.values.options[index].isCorrect
                            }
                            onChange={addContestFormik.handleChange}
                            disabled={showCheckbox(index)}
                            // required
                          />
                          <img
                            className="custom_trash"
                            src={trashIcon}
                            alt="delete icon"
                            onClick={() => {
                              addRemoveOptions(index);
                            }}
                          />
                        </div>
                      </div>
                      <div className="input_field custom_field custom_text">
                        <input
                          // required
                          type="text"
                          className="input custom_input"
                          name={`options[${index}].title.en`}
                          placeholder="Enter title"
                          value={
                            addContestFormik.values.options[index].title.en
                          }
                          onChange={addContestFormik.handleChange}
                        />
                      </div>
                      <div className="input_field custom_field custom_text">
                        <input
                          // required
                          type="text"
                          className="input custom_input"
                          name={`options[${index}].title.hi`}
                          placeholder="Enter title"
                          value={
                            addContestFormik.values.options[index].title.hi
                          }
                          onChange={addContestFormik.handleChange}
                        />
                        {/* <div className="checkbox_div">
                          <input
                            style={{ width: "auto" }}
                            type="checkbox"
                            className="input"
                            name={`options[${index}].isCorrect`}
                            placeholder="Enter title"
                            checked={
                              addContestFormik.values.options[index].isCorrect
                            }
                            onChange={addContestFormik.handleChange}
                            // required
                          />
                          <img
                            className="custom_trash"
                            src={trashIcon}
                            alt="delete icon"
                            onClick={() => {
                              addRemoveOptions(index);
                            }}
                          />
                        </div> */}
                      </div>
                      <div className="input_field custom_field custom_text">
                        <input
                          // required
                          type="text"
                          className="input custom_input"
                          name={`options[${index}].title.mr`}
                          placeholder="Enter title"
                          value={
                            addContestFormik.values.options[index].title.mr
                          }
                          onChange={addContestFormik.handleChange}
                        />
                        {/* <div className="checkbox_div">
                          <input
                            style={{ width: "auto" }}
                            type="checkbox"
                            className="input"
                            name={`options[${index}].isCorrect`}
                            placeholder="Enter title"
                            checked={
                              addContestFormik.values.options[index].isCorrect
                            }
                            onChange={addContestFormik.handleChange}
                            // required
                          />
                          <img
                            className="custom_trash"
                            src={trashIcon}
                            alt="delete icon"
                            onClick={() => {
                              addRemoveOptions(index);
                            }}
                          />
                        </div> */}
                      </div>
                    </div>
                  ) : optionType == "IMAGE" ? (
                    <div className="input-box ">
                      <div className="input-label ">Option {index + 1}</div>
                      <div className="custom_img_option">
                        <ThumbnailPicker
                          width="100px%"
                          height="250px"
                          onFileSelect={(file) => {
                            const _URL = window.URL || window.webkitURL;

                            const img = new Image();
                            uploadMediaImage(file, 2, index);

                            img.src = _URL.createObjectURL(file);
                          }}
                          image={
                            addContestFormik.values?.options[index].title.en
                          }
                          accept={"image/*"}
                        />
                        <div className="checkbox_div">
                          <input
                            style={{ width: "auto" }}
                            type="checkbox"
                            className="input"
                            name={`options[${index}].isCorrect`}
                            placeholder="Enter title"
                            value={
                              addContestFormik.values.options[index].isCorrect
                            }
                            checked={
                              addContestFormik.values.options[index].isCorrect
                            }
                            onChange={addContestFormik.handleChange}
                            disabled={showCheckbox(index)}
                            // required
                          />
                          <img
                            className="custom_trash"
                            src={trashIcon}
                            alt="delete icon"
                            onClick={() => {
                              addRemoveOptions(index);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>

          <div>
            <div>
              <div className="input-box ">
                <div className="flex_btn">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={addMoreOptions}
                    disabled={
                      addContestFormik.values.options.length >= 4 ||
                      addContestFormik.isSubmitting
                    }>
                    Add More Option
                  </button>
                  <button
                    className="btn btn-success"
                    type="submit"
                    disabled={
                      addContestFormik.values.options.length == 0 ||
                      loading ||
                      addContestFormik.isSubmitting
                    }>
                    {addContestFormik.isSubmitting ? "Submitting..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContestEdit;
